export default __webpack_public_path__ + "static/media/phone.47a86cd3.svg";